import { useTranslation } from "react-i18next";
import LegalPage, { type LegalSection } from "./LegalPage";

export default function RefundPolicy() {
  const { t } = useTranslation();
  const sections = t("legal.refund.sections", { returnObjects: true }) as LegalSection[];

  return (
    <LegalPage
      title={t("common.legal.refundPolicy")}
      updated={t("legal.refund.updated")}
      sections={sections}
    />
  );
}
